import { ApplicationNames } from '@ddt-web/domain';

export class AnalyticsHelperUtil {
	public static getPageName(url: string): string {
		url = url.replace('/', '');
		return url.indexOf('?') > -1 ? url.slice(0, url.indexOf('?')) : url;
	}

	public static getAnalyticsAppKey(appName: keyof ApplicationNames): string {
		switch (appName) {
			case ApplicationNames.PORTFOLIO_CENTRE:
				return 'pc';
			case ApplicationNames.PORTFOLIO_CENTRE_360:
				return 'pc-360';
			case ApplicationNames.CMA_ESTIMATOR:
				return 'cma';
			case ApplicationNames.INVESTMENT_QUALITY:
				return 'iq';
		}
	}
}
